import GenericCard from "widgets/cards/generic";
import TransferWizard from "widgets/shared/transferWizard";
import { setLoading } from "store/appSlice";
import { deviceTransferMany } from "api/device";
import { DeviceTransferReqBody } from "api/types/device";
import { notifySimple } from "providers/toast";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { t } from "i18next";

const TransferWizardPage = () => {
  const dispatch = useDispatch();
  const [resetTrigger, setResetTrigger] = useState(0);

  const onSubmit = async (formData: any) => {
    dispatch(setLoading(true));
    const body: DeviceTransferReqBody = {
      siteId: formData.siteId,
      accountId: formData.accountId,
      snrs: formData.snrs,
    };

    const { status, isLoading } = await deviceTransferMany(body);
    dispatch(setLoading(isLoading));

    if (status && status === 200) {
      notifySimple(t("notification.success"), "success");
      setResetTrigger(resetTrigger + 1);
    } else {
      notifySimple(t("notification.error"), "error");
    }
  };

  return (
    <GenericCard
      title={t("device.transfer.title")}
      description={t("device.transfer.description")}
      extraDescription="text-secondary"
      extra="h-full"
    >
      <TransferWizard onSubmit={onSubmit} resetTrigger={resetTrigger} />
    </GenericCard>
  );
};

export default TransferWizardPage;
